// src/components/facility/panels/FinancePanel.js
import React from 'react';

function StatRow({ label, value, color }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px 0', borderBottom: '1px solid #1e1c16' }}>
      <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{label}</span>
      <span style={{ fontSize: 13, fontWeight: 700, color: color || 'var(--text)' }}>{value}</span>
    </div>
  );
}

export function FinancePanel({ state }) {
  const cashColor = state.cash < 0 ? 'var(--red)' : state.cash < 5000 ? 'var(--yellow)' : 'var(--green)';
  const activeContracts = (state.activeContracts || []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      {/* Key stats */}
      <div>
        <div style={{ fontSize: 11, color: 'var(--text-dim)', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Financial Summary</div>
        <StatRow label="Cash on Hand"   value={`$${Math.round(state.cash).toLocaleString()}`}        color={cashColor} />
        <StatRow label="Weekly Burn"    value={`$${(state.weeklyBurn || 0).toLocaleString()}/wk`}    color="var(--yellow)" />
        <StatRow label="Total Revenue"  value={`$${(state.totalRevenue || 0).toLocaleString()}`}     color="var(--green)" />
        <StatRow label="Total Expenses" value={`$${(state.totalExpenses || 0).toLocaleString()}`}    color="var(--red)" />
      </div>

      {/* Contracts */}
      {activeContracts.length > 0 && (
        <div>
          <div style={{ fontSize: 11, color: 'var(--text-dim)', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Active Contracts</div>
          {activeContracts.map(c => {
            const pct = Math.min(100, Math.round(((c.gramsDelivered || 0) / c.gramsRequired) * 100));
            const daysLeft = c.deadlineDay - state.gameDay;
            return (
              <div key={c.id} style={{ background: '#1a1810', border: '1px solid #2a2618', borderRadius: 6, padding: '8px 10px', marginBottom: 6 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                  <span style={{ fontSize: 12, fontWeight: 600 }}>{c.label || c.id}</span>
                  <span style={{ fontSize: 11, color: daysLeft < 7 ? 'var(--red)' : 'var(--text-muted)' }}>
                    {daysLeft}d left
                  </span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: 'var(--text-muted)', marginBottom: 4 }}>
                  <span>{c.gramsDelivered || 0}g / {c.gramsRequired}g</span>
                  <span style={{ color: 'var(--green)' }}>${((c.valuePerGram || 0) * c.gramsRequired).toLocaleString()}</span>
                </div>
                <div style={{ height: 4, background: '#2a2618', borderRadius: 2, overflow: 'hidden' }}>
                  <div style={{ height: '100%', width: `${pct}%`, background: pct === 100 ? 'var(--green)' : 'var(--blue)', borderRadius: 2, transition: 'width 0.3s' }} />
                </div>
              </div>
            );
          })}
        </div>
      )}

      {activeContracts.length === 0 && (
        <div style={{ fontSize: 12, color: 'var(--text-dim)', textAlign: 'center', padding: '16px 0' }}>
          No active contracts. Visit the Market to sign one.
        </div>
      )}
    </div>
  );
}
